// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

// #region Imports

import * as _ from 'lodash';

// #endregion

// #region Types
// #endregion

var useKey = function useKey(value, key, predicate) {
  if (predicate === void 0) {
    predicate = function predicate(val) {
      return !!val;
    };
  }
  return value && (_.isFunction(predicate) && predicate(value) || _.isBoolean(predicate) && predicate || value === predicate ? key : '');
};
export default useKey;